var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React from 'react';
import PropTypes from 'prop-types';
import * as SharedStyle from '../../shared-style';
import If from '../../utils/react-if';
import { GeometryUtils } from '../../utils/export';

var STYLE = { fill: "#0096fd", stroke: SharedStyle.COLORS.white, cursor: "move" };
var STYLE_GREEN = { fill: "green", stroke: SharedStyle.COLORS.white, cursor: "move" };

export default function Vertex(_ref) {
  var vertex = _ref.vertex,
      layer = _ref.layer,
      isDesktop = _ref.isDesktop;
  var x = vertex.x,
      y = vertex.y;

  var isLast = false;
  if (vertex.selected) {
    var firstVertex = layer.getIn(['selected', 'vertices', '0']);
    var secondVertex = layer.getIn(['selected', 'vertices', '1']);
    var v_0 = layer.getIn(['vertices', firstVertex]);
    var v_1 = layer.getIn(['vertices', secondVertex]);

    var _GeometryUtils$orderV = GeometryUtils.orderVertices([v_0, v_1]),
        _GeometryUtils$orderV2 = _slicedToArray(_GeometryUtils$orderV, 2),
        v_a = _GeometryUtils$orderV2[0],
        v_b = _GeometryUtils$orderV2[1];

    if (v_b && v_b.id === vertex.id) isLast = true;
  }

  var radius = isDesktop ? 7 : 20;
  var strokeWidth = isDesktop ? 2 : 3;
  var devider = isDesktop ? 3 : 7;

  return React.createElement(
    'g',
    {
      transform: 'translate(' + x + ', ' + y + ')',
      'data-element-root': true,
      'data-prototype': vertex.prototype,
      'data-id': vertex.id,
      'data-selected': vertex.selected,
      'data-layer': layer.id
    },
    React.createElement('circle', { cx: '0', cy: '0', r: radius, style: STYLE }),
    React.createElement(
      If,
      { condition: isLast },
      React.createElement(
        'g',
        null,
        React.createElement('line', { x1: 0, x2: 0, y1: -radius + devider, y2: radius - devider, style: { stroke: 'white', strokeWidth: strokeWidth } }),
        React.createElement('line', { x1: -radius + devider, x2: radius - devider, y1: 0, y2: 0, style: { stroke: 'white', strokeWidth: strokeWidth } })
      )
    )
  );
}

Vertex.propTypes = {
  vertex: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};